import React, { Suspense, useEffect } from 'react';
import Card, { CardBody } from '../../components/bootstrap/Card';
import PageWrapper from '../PageWrapper/PageWrapper';
import Page from '../Page/Page';
import SubHeader from '../SubHeader/SubHeader';
import ContentRoutes from './ContentRoutes';
import ChunkErrorBoundary from '../../components/error-boundary/ChunkErrorBoundary';
import { isChunkError, clearAllCaches } from '../../utils/chunkErrorHandler';

const LOADING = (
	<PageWrapper>
		<SubHeader>
			<div />
		</SubHeader>
		<Page>
			<div className='row h-100'>
				<div className='col-lg-6'>
					<Card stretch>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
				<div className='col-lg-6'>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
			</div>
		</Page>
	</PageWrapper>
);

const Content = () => {
	// Handle chunk loading errors globally
	useEffect(() => {
		const handleError = (event: ErrorEvent) => {
			const error = event.error || { message: event.message };
			if (isChunkError(error)) {
				console.warn('Chunk loading error detected, clearing cache...');
				clearAllCaches().then(() => {
					setTimeout(() => {
						window.location.reload();
					}, 1000);
				});
			}
		};

		const handleRejection = (event: PromiseRejectionEvent) => {
			if (isChunkError(event.reason)) {
				console.warn('Chunk loading promise rejection detected, clearing cache...');
				event.preventDefault();
				clearAllCaches().then(() => {
					setTimeout(() => {
						window.location.reload();
					}, 1000);
				});
			}
		};

		window.addEventListener('error', handleError);
		window.addEventListener('unhandledrejection', handleRejection);

		return () => {
			window.removeEventListener('error', handleError);
			window.removeEventListener('unhandledrejection', handleRejection);
		};
	}, []);

	return (
		<main className='content'>
			<ChunkErrorBoundary>
				<Suspense fallback={LOADING}>
					<ContentRoutes />
				</Suspense>
			</ChunkErrorBoundary>
		</main>
	);
};

export default Content;
